<template>
    <div>
        <el-dialog custom-class='isCurPay' title="" :visible.sync="isCurPay" width="30%" :before-close="handleClose">
            
            <el-dialog custom-class='paySuccess' append-to-body :visible.sync="paySuccess" width="30%" :showClose="false" :close-on-click-modal='false'>
                <div class="flex">
                    <h1 class="title">支付成功</h1>
                    <p class="des">{{downTime}}秒后跳转课程学习界面，进行学习！</p>
                </div>
            </el-dialog>

            <el-dialog custom-class='payError' append-to-body :visible.sync="payError" width="30%" :showClose="false" :close-on-click-modal='false'>
                <div class="flex">
                    <h1 class="title">支付失败</h1>
                    <p class="des">支付失败，请确认选择课程后重新发起支付</p>
                </div>
            </el-dialog>

            <div class="payContent flex">
                <h1 class="title">微信支付</h1>
                <p class="des">二维码有效时长为5分钟，请尽快支付</p>
                <div class="qrcode" id="qrcode"></div>
                <div class="bt">
                    <img src="~@/assets/images/scanning.png" alt="">
                    <span>请使用微信扫一扫 扫描二维码支付</span>
                </div>
            </div>
        </el-dialog>

        
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'  // 引入qrcode
export default {
    props: {
        isCurPay: {
            type: Boolean
        },
        qrcode:{
            type: String
        }
    },
    data () {
        return {
            paySuccess: false,
            payError:false,
            downTime:5,
            createCode : null
        }
    },
    watch: {
        isCurPay () {
            if (this.isCurPay) {
                this.createCode = setTimeout(() => {
                    new QRCode('qrcode', {
                        width: 200,
                        height: 200,
                        text: this.qrcode, // 二维码地址
                    })
                }, 1000)
            }else{
                clearTimeout(this.createCode);
                document.getElementById('qrcode').innerHTML = '';
            }
            return this.isCurPay;
        }
    },
    mounted () {

    },
    methods: {
        handleClose () {
            this.$emit('closeCurPay');
        },
        toPay () {

        },
        closeSuccess(){

        }
    }
}
</script>
<style lang="stylus">
.isCurPay
    width 700px !important
    border-radius 8px
.paySuccess,.payError
    width 600px
    border-radius 8px
    text-align center
    .el-dialog__header
        display none
    .title
        color $textColorBlue
        font-size 22px
        margin-bottom 25px
.payContent
    text-align center
    .title
        color #333333
        font-size 20px
        margin-bottom 27px
    .des
        font-size 14px
        color $textColorGary
        margin-bottom 36px
    .qrcode
        width 260px
        height 230px
        margin auto
        padding-top 30px
        border 1px solid #CBCBCB
        img
            margin auto
    .bt
        margin-top 50px
        img
            vertical-align middle
            width 38px
            margin-right 16px
        span
            width 120px
            display inline-block
            vertical-align middle
            font-size 14px
            color #333333
</style>


// WEBPACK FOOTER //
// src/components/my/pay/wechatPay.vue